import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useState } from 'react';
import AddIcon from '../resources/images/icons-add.svg';
import ChevronDownWhiteIcon from '../resources/images/icons-chevron-down-white.svg';
import { Button } from './Button';

interface NewEmployeeButtonProps {
  translate: (key: string) => string;
  theme: any;
  onSelectFullAccess: () => void;
  onSelectLimitedAccess: () => void;
}

export function NewEmployeeButton({
  translate,
  theme,
  onSelectFullAccess,
  onSelectLimitedAccess,
}: NewEmployeeButtonProps) {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => setMenuAnchor(e.currentTarget);
  const handleClose = () => setMenuAnchor(null);

  return (
    <>
      <Button
        size='md'
        theme={theme}
        variant='filled'
        startIcon={<AddIcon />}
        endIcon={<ChevronDownWhiteIcon />}
        label={translate('settingsViews.employees.newEmployee')}
        onClick={handleOpen}
      />
      <Menu
        open={menuAnchor !== null}
        anchorEl={menuAnchor}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            onSelectFullAccess();
          }}
        >
          <ListItemText>{translate('settingsViews.employees.fullAccessLabel')}</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            onSelectLimitedAccess();
          }}
        >
          <ListItemText>{translate('settingsViews.employees.limitedAccessLabel')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
